import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: '/assets/i18n/{{lng}}.json',
    },
    fallbackLng: 'sr',
    // debug should be false in production
    debug: true,
    // at the moment there are only 2 namespaces ("common" and "signin")
    // ns: ['common', 'signin'],
    interpolation: {
      escapeValue: false,
      formatSeparator: ',',
    },
    react: {
      wait: true,
    },
  });
